import React, { useState, useEffect } from 'react';
import { extname } from 'path';
import { replace } from 'lodash';

import styles from './Audio.module.scss';

function Audio({ url }) {
  const [forceRender, setForceRender] = useState(false);

  useEffect(() => {
    setForceRender(true);
  }, [url]);

  useEffect(() => {
    forceRender && setForceRender(false);
  }, [forceRender]);

  if (forceRender) return null;

  return (
    <audio controls autoPlay controlsList="nodownload" className={styles.Audio}>
      <source src={url} type={`audio/${replace(extname(url), '.', '')}`} />
      Your browser does not support the audio element.
    </audio>
  );
}

export default Audio;
